import { ChangeDetectionStrategy, Component, HostBinding, Input, Optional } from '@angular/core';
import { TableHeaderRowComponent } from './table-header-row.component';
import { TableComponent } from './table.component';

@Component({
  selector: 'mtg-table-col-group',
  templateUrl: './table-col-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableColGroupComponent {
  @Input()
  title: string;

  @HostBinding('class.table-cell-group-header')
  get isHeader() {
    return this.header;
  }

  @HostBinding('class.table-cell-group')
  get isContent() {
    return !this.header;
  }

  constructor(
    @Optional() public header: TableHeaderRowComponent,
    private table: TableComponent,
  ) {
    table.withGroups = true;
  }
}
